import {snackbarStore} from "../../mobx/ui/SnackbarStore";
import {useSnackbar} from "notistack";
import {useEffect} from "react";

export function useNotifier() {
    const { notifier } = snackbarStore;
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();

    useEffect(() => {
        if (notifier.message) {
            const action = notifier.action ? notifier.action(closeSnackbar) : undefined;
            enqueueSnackbar(notifier.message, { autoHideDuration: 3000, ...notifier.options, action });
        }
    }, [enqueueSnackbar, notifier]);
}